import{b as z}from"./utils-BuG-uH50.js";const B=e=>{const a=new Set;return e.forEach(t=>{const d=(t.products?t.products[0]:t).custom,o=(d==null?void 0:d.product_sets_top)||[],c=(d==null?void 0:d.products_sets_bottom)||[];[...o,...c].forEach(n=>{n.id&&a.add(n.id)})}),[...a]},G=async e=>{var i,s;if(!e.length)return{};const a="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,[,l]=window.location.pathname.split("/"),o=((l||"").split("-")[1]||"gb").toUpperCase(),c=e.map(r=>`gid://shopify/Product/${r}`),n=`
    query GetSetProductPrices($ids: [ID!]!) @inContext(country: ${o}) {
      nodes(ids: $ids) {
        ... on Product {
          id
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `;try{const h=await(await fetch(a,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:n,variables:{ids:c}})})).json(),_={};return(s=(i=h.data)==null?void 0:i.nodes)==null||s.forEach(p=>{if(p!=null&&p.id){const b=p.id.replace("gid://shopify/Product/","");_[b]=parseFloat(p.priceRange.minVariantPrice.amount)}}),_}catch(r){return console.error("Failed to fetch set product prices:",r),{}}},E=(e,a)=>{if(!a||!Object.keys(a).length)return null;const t=e.custom,l=(t==null?void 0:t.product_sets_top)||[],d=(t==null?void 0:t.products_sets_bottom)||[],o=[...l,...d];if(!o.length)return null;let c=1/0;return o.forEach(n=>{const i=a[n.id];i!==void 0&&i<c&&(c=i)}),c===1/0?null:c},M=(e,{isSlide:a=!1,index:t=99,setProductPrices:l={}}={})=>{var w,k,u,v,P,S,C,I,V,x;const{key:d,title:o,link:c,imageInfo:n,sellingPrice:i,listPrice:s,custom:r,ticket:h}=e,_=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",p=((v=(u=(k=(w=n==null?void 0:n.images)==null?void 0:w[0])==null?void 0:k.sources)==null?void 0:u[0])==null?void 0:v.url)||(n==null?void 0:n.thumbnail)||"",b=(i==null?void 0:i.min)||0,g=(s==null?void 0:s.min)>(i==null?void 0:i.min)?s.min:0,f=(S=(P=r==null?void 0:r.product_hover_image)==null?void 0:P[0])==null?void 0:S.label,$=(I=(C=r==null?void 0:r.colour_count)==null?void 0:C[0])==null?void 0:I.label,F=t<=2?"eager":"lazy",T=t<=2?"high":"auto",y=((V=r==null?void 0:r.product_sets_top)==null?void 0:V.length)>0||((x=r==null?void 0:r.products_sets_bottom)==null?void 0:x.length)>0?E(e,l):null;return`
    <${a?"li":"div"}
      class="product-card ${a?"splide__slide":""}"
      data-voyado-product
      data-product-key="${d}"
      data-product-ticket="${h}"
    >
      ${A(r,b,g)}
      ${H(e)}
      <a
        href="${_}${c}"
        class="product-card__image-container ${f?"has-hover":""}"
        aria-label="${o}"
      >
        <img
          src="${p}"
          alt="Image of ${o}"
          class="product-card__image-container--primary"
          width="600"
          height="800"
          loading="${F}"
          fetchpriority="${T}"
        />
        ${f?`
          <img
            src="${f}"
            alt="Secondary image of ${o}"
            class="product-card__image-container--secondary"
            width="600"
            height="800"
            loading="lazy"
          />
        `:""}
      </a>
      <div class="product-card__content">
        <p class="product-card__title f1-lc">${o}</p>
        ${y!==null?O(y):q(b,g)}
      </div>
       <p
        data-product-id="${d}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${$&&$>1?`
        <p class="product-card__colour-count f2-lc">
          ${$} Colours
        </p>
      `:""}
    </${a?"li":"div"}>
  `},O=e=>`
    <div class="product-card__price">
      <span class="product-card__price--current f1-lc">
        From ${z(e)}
      </span>
    </div>`,q=(e,a)=>{let t="",l="product-card__price--current";return a&&(t=`
      <span class="product-card__price--original f1-lc">
        ${z(a)}
      </span>
    `,l="product-card__price--discounted"),`
    <div class="product-card__price">
      ${t}
      <span class="${l} f1-lc">
        ${z(e)}
      </span>
    </div>`},A=(e,a,t)=>{var d,o,c,n,i,s,r,h,_,p,b,g,f,$,F,T,j,y,w,k,u,v,P,S,C,I,V,x;if(a&&t&&a<t)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-a/t)*100)}% OFF
      </p>
    `;let l="";return(o=(d=e==null?void 0:e.stock)==null?void 0:d[0])!=null&&o.label?l=(n=(c=e==null?void 0:e.stock)==null?void 0:c[0])==null?void 0:n.label:(s=(i=e==null?void 0:e.petite)==null?void 0:i[0])!=null&&s.label?l=(h=(r=e==null?void 0:e.petite)==null?void 0:r[0])==null?void 0:h.label:(p=(_=e==null?void 0:e.collection)==null?void 0:_[0])!=null&&p.label?l=(g=(b=e==null?void 0:e.collection)==null?void 0:b[0])==null?void 0:g.label:($=(f=e==null?void 0:e.new)==null?void 0:f[0])!=null&&$.label?l=(T=(F=e==null?void 0:e.new)==null?void 0:F[0])==null?void 0:T.label:(y=(j=e==null?void 0:e.back_in_stock)==null?void 0:j[0])!=null&&y.label?l=(k=(w=e==null?void 0:e.back_in_stock)==null?void 0:w[0])==null?void 0:k.label:(v=(u=e==null?void 0:e.available_to_rent)==null?void 0:u[0])!=null&&v.label?l=(S=(P=e==null?void 0:e.available_to_rent)==null?void 0:P[0])==null?void 0:S.label:(I=(C=e==null?void 0:e.nc_exclusive)==null?void 0:C[0])!=null&&I.label&&(l=(x=(V=e==null?void 0:e.nc_exclusive)==null?void 0:V[0])==null?void 0:x.label),l?`
      <p class="product-card__label product-label product-label--default">
        ${l}
      </p>
    `:""},H=e=>{var t;const a=((t=e.link)==null?void 0:t.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${e.key}"
      data-product-handle="${a}"
      role="button"
      tabindex="0"
      aria-label="Add to wishlist"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{M as b,B as c,G as f};
